<template>
  <a-flex class="root">
    <a-col :span="24">
      <div class="instructions">
        На этой странице Вы можете отслеживать, какие качества сформировались у
        участников проектов этого портфеля, а также проводить анализ соотношения
        ожидаемых и фактических результатов.
      </div>
    </a-col>

    <a-col :span="24">
      <a-flex class="cards">
        <portfolio-qualities-card
          title="Накопленные качества исполнителей"
          :items="qualities"
        />
      </a-flex>
    </a-col>
  </a-flex>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import { useRoute } from 'vue-router';
  import PortfolioQualitiesCard from '@/components/projects/portfolio/components/PortfolioQualitiesCard.vue';

  const api = useApi();
  const route = useRoute();
  const qualities = ref([]);
  const isLoading = ref(true);

  onMounted(async () => {
    await getStats();
    isLoading.value = false;
  });

  const getStats = async () => {
    try {
      const response = await api.briefcaseQuality.stats(
        new URLSearchParams({
          briefcaseId: route.params.id,
        })
      );

      qualities.value = response.qualities.items;
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style scoped lang="scss">
  .root {
    flex-direction: column;

    .instructions {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 40px;
      max-width: 555px;
    }

    .cards {
      flex-direction: column;
      row-gap: 10px;
      margin-top: 30px;
    }
  }
</style>
